import { ExternalGoods } from "./goods.model"
import { ExternalFreightForwarderResponse } from "./FreightForwarderResponse.model"
import { ExternalTimeWindow } from "./timewindow.model"

export interface ExternalBuyer {
    name: string
    address?: ExternalAddress
}

export interface ExternalAddress {
    street: string
    postal_code: string
    city: string
    country: string
}

export interface ExternalContact {
    name?: string
    email?: string
    phone?: string
}

export interface ExternalPartyExternalIdentifiers {
    duns?: string
    plant_code?: string
    supplier_code?: string
}

export interface ExternalSupplier {
    name?: string
    address?: ExternalAddress
    external_identifiers: ExternalPartyExternalIdentifiers
}

export interface ExternalShippingParty {
    name: string
    address: ExternalAddress
    contact?: ExternalContact
    external_identifiers: ExternalPartyExternalIdentifiers
}

export interface ExternalStartOfTransportChain {
    consignor: ExternalShippingParty
    pickup_requested_at: ExternalTimeWindow
    access_code?: string
    place_of_loading?: string
}

export interface ExternalEndOfTransportChain {
    consignee: ExternalShippingParty
    delivery_estimated_at?: ExternalTimeWindow
    access_code?: string
    place_of_discharge?: string
}

export interface ExternalCurrentTransportLegParty {
    name?: string
    address?: ExternalAddress
    external_identifiers: ExternalPartyExternalIdentifiers
}

export interface ExternalCurrentTransportLeg {
    place_of_departure: ExternalCurrentTransportLegParty
    departure_requested_at?: ExternalTimeWindow
    place_of_arrival: ExternalCurrentTransportLegParty
    arrival_estimated_at?: ExternalTimeWindow
}

export interface ExternalFreightPayer {
    name: string
}

export enum ExternalPriority {
    REGULAR = "REGULAR",
    URGENT = "URGENT",
}

export type ExternalProposedVehicleType = "PASSENGER_CAR" | "VAN" | "LIGHT_TRUCK" | "MEDIUM_TRUCK"

export interface ExternalTransportOrder {
    id: string
    bundle_id: string
    external_id: string
    brand?: string | null
    external_consignment_reference_number?: string
    cancelled?: boolean
    process_indicator: "LTL" | "FTL" | "KEP"
    freight_payer?: ExternalFreightPayer
    buyer?: ExternalBuyer
    supplier: ExternalSupplier
    freight_forwarder: ExternalFreightForwarder
    proposed_vehicle_type?: ExternalProposedVehicleType
    requires_two_drivers?: boolean
    priority: ExternalPriority
    start_of_transport_chain: ExternalStartOfTransportChain
    end_of_transport_chain: ExternalEndOfTransportChain
    current_transport_leg: ExternalCurrentTransportLeg
    goods: ExternalGoods
    freight_forwarder_response?: ExternalFreightForwarderResponse
    last_modified_at: string
    external_order_created_date: string
    etag: number
}

export interface ExternalFreightForwarder {
    name: string
    duns: string
    account_id?: string
    supplier_code: string
    address?: ExternalAddress
}

export interface ExternalTransportOrderBundle {
    id: string
    external_bundle_id?: string
    created_at: string
    _embedded: {
        transport_orders: Array<ExternalTransportOrder>
    }
}

export interface ExternalTransportOrderBundleList {
    items: ExternalTransportOrderBundle[]
}

export interface ExternalTransportOrderList {
    items: ExternalTransportOrder[]
}
